import _ from 'lodash';
import infoBoard from '../core/infoboard';

const LayerControls = (name) => require('../controls').get(name);

export class DefaultType {
    constructor (options) {
        const defaults = {
            change: null,
            dropdown: null,
            icon: '',
            id: '',
            input: null,
            layer: null,
            name: '',
            tab: null,
            type: '',
            url: '#',
            controls: {},
            switch: {}
        };

        options.change = options.change || this._change;
        this.options = _.assign({}, defaults, options);
    }

    check (state = null, change = true) {
        try {
            const controls = LayerControls(this.options.name).getControls();
            if (!controls.switch || !controls.switch.onOff) return;

            const onOff = controls.switch.onOff;
            const input = onOff.input;

            if (!input) return;

            input.enable(true);

            if (input.check() === state) return;

            if (_.isBoolean(state)) {
                input.check(state);
                onOff.status = state;

                infoBoard.toggleContext(this.options);
                if (change) {
                    this.options.change({ checked: state });
                }

                return state;
            } else {
                return input.check();
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export default DefaultType;



// WEBPACK FOOTER //
// ./src/scripts/controls/DefaultType.js